import SetEmailPrompt from "../components/SetEmailPrompt";
import Layout from "../components/Layout";
import { Container } from "@mui/material";

export default function SetEmailPromptPage() {
  return (
    <Layout title="Add Email" content="Add Email Page">
      <Container component="main" maxWidth="xs">
        <SetEmailPrompt />
      </Container>
    </Layout>
  );
}
